import { type FC, useState } from 'react';

import { useEventBatchGetQuery } from '../../../../hooks/react-query/useEventsQuery';
import { PropertyHistory } from './PropertyHistory';

interface PropertyHistoryWrapperProps {
  propertyId: number;
  currentEventId?: number;
}

export const PropertyHistoryWrapper: FC<PropertyHistoryWrapperProps> = ({
  propertyId,
  currentEventId,
}) => {
  const [currentPage, setCurrentPage] = useState(0);

  // Fetch events data - fetch ALL for client-side pagination
  const {
    data: eventsData,
    isLoading: isEventsLoading,
    error: eventsError,
  } = useEventBatchGetQuery({
    filters: {
      propertyId,
      withoutLimit: true,
      isActive: 1,
      id: currentEventId || 0,
      notEquals: currentEventId ? ['Id'] : undefined,
    },
    enabled: !!propertyId,
  });

  return (
    <PropertyHistory
      eventsData={eventsData}
      isLoading={isEventsLoading}
      error={eventsError}
      currentPage={currentPage}
      onPageChange={setCurrentPage}
    />
  );
};
